define('app-ProductFloatingBoxRight/main',['./settings'], function (settings) {
    return {
        run: function () {
            if (settings.container.length <= 0) {
                window.log("Product floating box not found, script will not be run.");
                return;
            }

            function floatingInfoBoxScroll() {
                if ($(window).width() >= 768) {
                    var scrollTop = $(window).scrollTop();
                    var boxWidth = $(".leftNav").width();
                    var boxHeight = $("#scrollLookup").outerHeight();
                    var boxBottom = $("#scrollLookup").offset().top + boxHeight;

                    if ($('#cruise-product').is(":visible")) {
                        var containerTop = $('.ScrollContainer').offset().top;
                        var containerHeight = $(".ScrollContainer").outerHeight();
                        var containerBottom = containerTop + containerHeight - 20;

                        var diff = containerBottom - scrollTop - boxHeight;

                        if ((scrollTop) > (parseFloat(containerTop))) {
                            if ((scrollTop) > (parseFloat(containerBottom - boxHeight))) {
                                $('#scrollLookup').css({ 'position': 'fixed', 'top': diff + 'px', 'width': boxWidth + 'px' });
                            }
                            else {
                                $('#scrollLookup').css({ 'position': 'fixed', 'top': '0px', 'width': boxWidth + 'px' });

                            }
                        } else {
                            $('#scrollLookup').css({ 'position': 'relative', 'width': 'auto' });
                        }
                        
                    }
                    else {
                        //var productContentTopHeight = $(".productContentTop").outerHeight();
                        var navHeight = 0;
                        if ($('.footer').is(':visible')) {
                            navHeight = $(".meganav").outerHeight();
                        }
                        var sliderTop = $('.leftNav').offset().top - $('.slider').offset().top;
                        //var leftNavHeight = $('.leftNav').offset().top + 15 - navHeight - productContentTopHeight;

                        if ((scrollTop) > (parseFloat($('.slider').offset().top - navHeight - 15))) {
                            $('#scrollLookup').css({ 'position': 'fixed', 'top': navHeight + 15 + 'px', 'width': boxWidth + 'px' });
                        } else {
                            $('#scrollLookup').css({ 'position': 'relative', 'top': '-' + sliderTop + 'px' , 'width': 'auto' });
                        }

                        var productInfoBottom = $('#bottomProductInfoHolder').height();
                        var elementOffset = 0;
                        if ($('.footer').is(':visible')) {
                            elementOffset = $('.footer').offset().top - productInfoBottom - 220;
                        }
                        else {
                            elementOffset = $('#gn-footer-2021').offset().top - productInfoBottom - 220;

                        }

                        var diff = boxBottom - elementOffset - 15;
                    
                        if ((boxBottom) > (parseFloat(elementOffset))) {
                            $('#scrollLookup').css({ 'position': 'fixed', 'top': navHeight - diff + 'px', 'width': boxWidth + 'px' });
                        } else {
                        }
                    }

                }
            }


            floatingInfoBoxScroll();

            $(window)
                .scroll(function () {
                    floatingInfoBoxScroll();
                })
                .resize(function () {
                    floatingInfoBoxScroll();
                });
        }
    };
});
